
    const data = {"name":"src/core/icons/menu","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M3 6h18v2H3V6m0 5h18v2H3v-2m0 5h18v2H3v-2Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            